import { FairlyPrioritizedUsers } from '@chilipiper/api-client/src/distribution'
import { Assignment } from '@chilipiper/api-client/src/meetings'
import { AssignmentRequest } from '@chilipiper/api-client/src/meetings-api'
import { RoundRobinAvailableAttendees } from '@chilipiper/api-client/src/user-availability'
import { indexBy } from 'remeda'

export const hasFlexibleReassignment = ({
  assignment,
  distributions,
}: {
  assignment?: Assignment
  distributions: Record<string, FairlyPrioritizedUsers>
}) => {
  if (!assignment) {
    return false
  }

  if (assignment.type === 'AssignedViaDistribution') {
    const distribution = distributions?.[assignment.distributionId]
    return (
      distribution?.assignmentTypeConfig.type === 'Meeting' &&
      distribution.assignmentTypeConfig.handling.type === 'Flexible' &&
      distribution.assignmentTypeConfig.handling.reassignmentType === 'AnyTeamMember'
    )
  }
}

export const parseRescheduleAssignmentsToScheduleByDistributionAssignees = (
  assigments: Assignment[],
  availableRoundRobinAssignees: RoundRobinAvailableAttendees[]
): AssignmentRequest[] => {
  const mappedAvailableAssignees = indexBy(
    availableRoundRobinAssignees || [],
    item => item.distributionId
  )
  return assigments.flatMap(item => {
    if (item.type === 'AssignedViaDistribution') {
      const availableAssignee = mappedAvailableAssignees[item.distributionId]

      if (!availableAssignee) {
        return []
      }

      return availableAssignee.type === 'StrictRoundRobin'
        ? {
            type: 'AssignedViaDistribution' as const,
            assigneeId: availableAssignee.userId,
            distributionId: item.distributionId,
          }
        : {
            type: 'WithUnresolvedDistribution' as const,
            availableUsers: availableAssignee.userIds,
            distributionId: item.distributionId,
          }
    }

    if (item.type === 'AssignedViaTeam') {
      return item
    }

    if (item.type === 'ManuallyAssigned') {
      return item
    }

    return []
  })
}
